module.exports = "/fonts/payjak-logotype-d-f8a1dba396165b0de97fc4295a3e5194.svg";